var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7071 0.292893C12.3166 -0.0976314 11.6834 -0.0976314 11.2929 0.292893C10.9024 0.683417 10.9024 1.31658 11.2929 1.70711L12.7071 0.292893ZM19 8L19.7071 8.70711C20.0976 8.31658 20.0976 7.68342 19.7071 7.29289L19 8ZM11.2929 14.2929C10.9024 14.6834 10.9024 15.3166 11.2929 15.7071C11.6834 16.0976 12.3166 16.0976 12.7071 15.7071L11.2929 14.2929ZM1 7C0.447715 7 -2.81839e-07 7.44772 -3.0598e-07 8C-3.30121e-07 8.55228 0.447715 9 1 9L1 7ZM11.2929 1.70711L18.2929 8.70711L19.7071 7.29289L12.7071 0.292893L11.2929 1.70711ZM18.2929 7.29289L11.2929 14.2929L12.7071 15.7071L19.7071 8.70711L18.2929 7.29289ZM19 7L1 7L1 9L19 9L19 7Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.3a4b713ea264e212f76381ad9fd1ae59.svg";
export { ForwardRef as ReactComponent };